import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCatalogById } from '../../app/helpers/getCatalogById';
import { getObjectById } from '../../app/helpers/getObjectById';
import { getFieldInfo } from '../../app/helpers/getFieldInfo';
import { useTranslation } from 'react-i18next';
import "./tableComparison.css" // Asegúrate de que este CSS incluya los estilos sticky

const TableHorizontalFullAlternative = ({ data }) => {
  const { t } = useTranslation();

  // 1. Selectores de Redux específicos para Alternative
  const { listFieldsAlternative } = useSelector((state) => state.moduleConfig);
  const { listFullCatalogs } = useSelector((state) => state.catalog);
  const { listFullCatalogCiius } = useSelector((state) => state.catalogCiiu);
  const { listContinents, listFullRegions, listFullCountries } = useSelector((state) => state.locationCountry);

  // 2. Filtros Memoizados (Mejor rendimiento)
  const comparedData = useMemo(() => data.filter(dta => dta.isSelected || dta.isCompared), [data]);
  const comparableFields = useMemo(() => listFieldsAlternative.filter(f => f.is_comparable), [listFieldsAlternative]);

  // 3. Resolver de valores (Refactorizado)
  const resolveCellValue = (fieldKey, dataObject) => {
    const fieldFound = getFieldInfo(fieldKey, listFieldsAlternative);
    if (!fieldFound || !fieldFound.is_comparable) return null;

    const val = dataObject[fieldKey];
    const condition = fieldFound.comparable_relation_condition;

    const resolvers = {
      "Fields": () => val,
      "Catalogs": () => getCatalogById(val, listFullCatalogs)?.description,
      "CatalogCiius": () => getObjectById(val, listFullCatalogCiius)?.name,
      "CatalogSections": () => getObjectById(val, listFullCatalogCiius)?.name,
      "CatalogPhases": () => getObjectById(val, listFullCountries)?.name,
      "CatalogCountries": () => getObjectById(val, listFullCountries)?.name,
      "CatalogRegions": () => getObjectById(val, listFullRegions)?.name,
      "CatalogContinents": () => getObjectById(val, listContinents)?.name,
      "Year": () => val ? new Date(val).getFullYear() : '',
    };

    return resolvers[condition] ? resolvers[condition]() : null;
  };

  return (
    <div className='table-horizontal-scroll-full'>
      <table className='table table-comparison'>
        <thead>
          <tr>
            {/* Esquina fija */}
            <th className="sticky-corner" style={{ left: 0, zIndex: 11 }}>
              {t('general.table.header.common.fields')}
            </th> 
            {comparedData.map((dta) => (
              <th key={`h-${dta.id}`} scope="col" className="text-center">
                <div className="text-primary">ID: {dta.id}</div>
                <small className="text-muted d-block">{dta.code}</small>
              </th>
            ))}
          </tr>
        </thead>
        
        <tbody>
          {comparableFields.map((fieldItem) => (
            <tr key={`row-${fieldItem.field}`}>
              {/* Columna de etiquetas fija */}
              <th scope="row" className="sticky-column">
                {t(`${fieldItem.module_text}.synthetic.${fieldItem.field}`)}
              </th>
              {comparedData.map((dta) => (
                <td key={`cell-${fieldItem.field}-${dta.id}`} className="align-middle">
                  {resolveCellValue(fieldItem.field, dta) || (
                    <span className="text-muted small">---</span>
                  )}
                </td>
              ))}
            </tr>
          ))}
          {comparedData.length === 0 && (
            <tr>
              <td colSpan={comparableFields.length + 1} className="text-center p-4">
                {t('general.no_data_compared')}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableHorizontalFullAlternative;
